"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarParkDetailsDomain = exports.SubmitCaseAttachmentDomain = exports.CaseUpdateApiDomain = exports.CaseApiDomain = exports.CaseSummaryApiDomain = void 0;
const core_1 = require("@js-joda/core");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const utils_1 = require("../../../utils");
const validators_1 = require("../../../utils/validators");
const enum_1 = require("./enum");
class CaseSummaryApiDomain {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.CaseSummaryApiDomain = CaseSummaryApiDomain;
__decorate([
    (0, validators_1.IsString)({ isOptional: false }),
    __metadata("design:type", String)
], CaseSummaryApiDomain.prototype, "oneServiceCaseId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.CaseStatus),
    __metadata("design:type", String)
], CaseSummaryApiDomain.prototype, "caseStatus", void 0);
__decorate([
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.ZonedDateTimeClassTransformer),
    __metadata("design:type", core_1.ZonedDateTime)
], CaseSummaryApiDomain.prototype, "lastUpdateDateTime", void 0);
class CaseApiDomain {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.CaseApiDomain = CaseApiDomain;
__decorate([
    (0, validators_1.IsString)({ isOptional: false }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "oneServiceCaseId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.CaseStatus),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "caseStatus", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.ZonedDateTimeClassTransformer),
    __metadata("design:type", core_1.ZonedDateTime)
], CaseApiDomain.prototype, "receivedDateTime", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.ZonedDateTimeClassTransformer),
    __metadata("design:type", core_1.ZonedDateTime)
], CaseApiDomain.prototype, "incidentDateTime", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: false }, { each: true }),
    __metadata("design:type", Array)
], CaseApiDomain.prototype, "attachments", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(enum_1.Category),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(enum_1.SubCategory),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "subCategory", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: false, maxLength: 300 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "subject", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: false, maxLength: 50000 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "description", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: false }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "address", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: false }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "shortAddress", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: false, maxLength: 200 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "incidentLocationDescription", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: true }),
    __metadata("design:type", Number)
], CaseApiDomain.prototype, "incidentLat", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: true }),
    __metadata("design:type", Number)
], CaseApiDomain.prototype, "incidentLng", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: false, isIn: [-1, 1, 2, 3, 4, 5] }),
    __metadata("design:type", Number)
], CaseApiDomain.prototype, "surveyRating", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(enum_1.HighriseLitterType),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "typesOfLitterThrown", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true, maxLength: 50 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "typesOfLitterIfOther", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true, maxLength: 1500 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "descriptionOfOffender", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: true, min: 1, max: 99 }),
    __metadata("design:type", Number)
], CaseApiDomain.prototype, "suspectedFloorFrom", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: true, min: 1, max: 99 }),
    __metadata("design:type", Number)
], CaseApiDomain.prototype, "suspectedFloorTo", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: true }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "suspectedUnit", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(enum_1.SuspectedWindowType, { each: true }),
    __metadata("design:type", Array)
], CaseApiDomain.prototype, "suspectedWindow", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true, maxLength: 50 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "suspectedWindowIfOther", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CaseUpdateApiDomain),
    __metadata("design:type", Array)
], CaseApiDomain.prototype, "updates", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CaseApiDomain.prototype, "isFromOSSG", void 0);
__decorate([
    (0, validators_1.IsNumber)({ isOptional: true, max: 99, min: 0 }),
    __metadata("design:type", Number)
], CaseApiDomain.prototype, "numberOfSmokers", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true, maxLength: 200 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "descriptionOfSmokers", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true, maxLength: 200 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "detailsOfStallSmoking", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true, maxLength: 26 }),
    __metadata("design:type", String)
], CaseApiDomain.prototype, "smokerUnitNumber", void 0);
class CaseUpdateApiDomain {
}
exports.CaseUpdateApiDomain = CaseUpdateApiDomain;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(enum_1.CaseDisplayStatus),
    __metadata("design:type", String)
], CaseUpdateApiDomain.prototype, "caseDisplayStatus", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true }),
    __metadata("design:type", String)
], CaseUpdateApiDomain.prototype, "agencyResponse", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true }),
    __metadata("design:type", String)
], CaseUpdateApiDomain.prototype, "providerName", void 0);
__decorate([
    (0, validators_1.IsString)({ isOptional: true }),
    __metadata("design:type", String)
], CaseUpdateApiDomain.prototype, "providerType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.ZonedDateTimeClassTransformer),
    __metadata("design:type", core_1.ZonedDateTime)
], CaseUpdateApiDomain.prototype, "updateDateTime", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, validators_1.IsString)({ isOptional: false }, { each: true }),
    __metadata("design:type", Array)
], CaseUpdateApiDomain.prototype, "attachments", void 0);
class SubmitCaseAttachmentDomain {
}
exports.SubmitCaseAttachmentDomain = SubmitCaseAttachmentDomain;
__decorate([
    (0, validators_1.IsString)({ isOptional: false }),
    __metadata("design:type", String)
], SubmitCaseAttachmentDomain.prototype, "path", void 0);
class CarParkDetailsDomain {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.CarParkDetailsDomain = CarParkDetailsDomain;
__decorate([
    (0, validators_1.IsString)({ maxLength: 10 }),
    __metadata("design:type", String)
], CarParkDetailsDomain.prototype, "carParkNumber", void 0);
__decorate([
    (0, validators_1.IsString)({ maxLength: 300 }),
    __metadata("design:type", String)
], CarParkDetailsDomain.prototype, "carParkName", void 0);
//# sourceMappingURL=api-domain.js.map